// interpreterInvoiceReportReducer.js

const InterpreterInvoiceReportReducer = (state, action) => {
  switch (action.type) {
    // Start / Clear State
    case "PROCESS_START":
      return {
        ...state,
        loading: false,
        interpreterInvoices: [],
        interpreters: [],
        clients: [],
        totalAmount: 0,
        totalVAT: 0,
        totalInvoice: 0,
        count: 0,
        error: null,
      };

    // Error Handling
    case "PROCESS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Interpreter Invoice Report
    case "FETCH_INTERPRETER_INVOICE_RECORDS":
      return {
        ...state,
        loading: false,
        interpreterInvoices: action.payload.data || [],
        totalAmount: action.payload.totalAmount || 0,
        totalVAT: action.payload.totalVAT || 0,
        totalInvoice: action.payload.totalInvoice || 0,
        count: action.payload.count || 0,
        error: null,
      };

    // Fetch Interpreters for Autocomplete
    case "FETCH_INTERPRETER_RECORDS":
      return {
        ...state,
        loading: false,
        // API response shape:
        // {
        //   success: true,
        //   count: 10,
        //   data: [...]
        // }
        interpreters: action.payload.data || [],
        error: null,
      };

    // Fetch Clients / Companies for Autocomplete
    case "FETCH_CLIENT_RECORD":
      return {
        ...state,
        loading: false,
        // API response shape:
        // {
        //   success: true,
        //   count: 10,
        //   data: [...]
        // }
        clients: action.payload.data || [],
        error: null,
      };

    default:
      return state;
  }
};

export default InterpreterInvoiceReportReducer;
